import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "layouts/layout";
import Table from "components/table/table";
import ListContainer from "components/list/list-container";
import ListHeader from "components/list/list-header";
import numeral from "numeral";
import _ from "lodash";
import moment from "moment";
import { Profile1 } from "constants/images";
import ActionIconBtn from "components/button/action-btn";
import SendAltIconSVG from "assets/svg/send-alt";
import CloudDownloadIconSVG from "assets/svg/cloud-download";
import EyeIconSVG from "assets/svg/eye-icon";
import { useDialogHook } from "utils/customhooks";
import InvoiceModal from "components/transaction/invoice-modal";
import { urlSerializer } from "utils/utils";

import {
  GET_TRANSACTIONS,
  SET_TRANSACTIONS,
} from "redux/modules/transaction-management/types";

export default function Transaction() {
  const { http } = global.services;
  const {
    transactions = [],
    page,
    limit,
    initialize,
    refresh,
    loadMore,
    isRequesting,
    pages = [],
  } = useSelector((state) => state.transactions);
  const [filterValue, setFilterValue] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const modal = useDialogHook(InvoiceModal);
  const dispatch = useDispatch();

  const getTransactions = async (selectedPage = null) => {
    if (isRequesting || !loadMore) return;

    dispatch({ type: GET_TRANSACTIONS, payload: [] });

    try {
      const url = urlSerializer("transactions-history", {
        page: selectedPage ?? page,
        limit: limit,
      });
      const { data } = await http.get(url);
      const _loadMore = data.data.length > 0 ? true : false;
      const _page = data.current_page;
      const _lastPage = data.last_page;

      dispatch({
        type: SET_TRANSACTIONS,
        payload: {
          data: data.data,
          loadMore: _loadMore,
          page: _page,
          lastPage: _lastPage,
        },
      });
    } catch (err) {
      console.log("error@getTransactions", err);
    }
  };

  const handleInvoiceSentView = (data = {}) => {
    modal(data, (result) => {
      if (!_.isEmpty(result)) {
        console.log("result ", result);
      }
    });
  };

  const columns = [
    {
      title: "Transaction ID",
      dataIndex: "transaction",
      nowrap: true,
      key: "transaction",
      render: (record) => <p>{record.id}</p>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      nowrap: true,
      key: "amount",
      render: (record) => <p>${numeral(record?.amount).format("0,0.00")}</p>,
    },
    {
      title: "Sent By",
      dataIndex: "sent",
      nowrap: true,
      key: "sent",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.sent ? (
            <>
              <img
                src={Profile1}
                alt="account"
                className="account-img mr-2.5"
              />
              <p>{record?.user?.email}</p>
            </>
          ) : (
            <p>{record?.user?.email}</p>
          )}
        </div>
      ),
    },
    {
      title: "Received By",
      dataIndex: "received",
      nowrap: true,
      key: "received",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.provider ? (
            <>
              <p>{record.provider}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      nowrap: true,
      key: "status",
      render: (record) => {
        let color = "green";
        if (record.subscription.status === "pending") {
          color = "orange";
        }
        return <p className={`text-${color} font-bold uppercase`}>{record.subscription.status}</p>;
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      nowrap: true,
      key: "date",
      render: (record) => <p>{moment(record.created_at).format("MMMM DD, YYYY")}</p>,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hideSorting: true,
      nowrap: true,
      render: (record) => (
        <>
          <ActionIconBtn
            icon={<EyeIconSVG className="m-auto" />}
            onClick={() => handleInvoiceSentView(record)}
          />
          <ActionIconBtn
            icon={<CloudDownloadIconSVG className="m-auto" />}
            onClick={() => console.log("download")}
          />
          <ActionIconBtn
            icon={<SendAltIconSVG className="m-auto" fill="#000" />}
            onClick={() => handleInvoiceSentView(record)}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    if (initialize) getTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, initialize]);

  return (
    <Layout title="Transaction" routeName="transaction">
      <div className="main-page-wrapper">
        <ListContainer
          header={
            <ListHeader
              title="List"
              countValue={_.size(transactions)}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
            />
          }
        >
          <Table
            columns={columns}
            dataSource={transactions}
            pagination={true}
            selectable={true}
            selected={selectedRows}
            onSelected={(selectedRows) => {
              setSelectedRows(selectedRows);
            }}
            perPage={10}
            currentPage={page}
            onHandleChangePage={getTransactions}
            pages={pages}
          />
        </ListContainer>
      </div>
    </Layout>
  );
}
